var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoldBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1170,
    height: 233,
    viewBox: "0 0 1170 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 16C0 7.16345 7.16344 0 16 0H148.518C153.601 0 158.425 2.1775 162.222 5.55621C169.089 11.667 181.117 20.6316 192.581 20.6316C208.667 20.6316 1031.17 20.6316 1154.57 20.6316C1163.41 20.6316 1170 27.7951 1170 36.6316V217C1170 225.837 1162.84 233 1154 233H16C7.16344 233 0 225.837 0 217V16Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldBig);
export default __webpack_public_path__ + "static/media/foldBig.63f82590f5fe56cc92751583bc3b4942.svg";
export { ForwardRef as ReactComponent };